const barColor = [
  "rgba(21, 175, 208, 1)",
  "rgba(229, 191, 33, 1)",
  "rgba(241, 127, 76, 1)"
];

const frameworkC1Options = {
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: function(context){
          return context.dataset.label+": "+context.parsed.y+"%"
        }
      }
    },
    datalabels: {
      display: false
    },
    title: {
      display: true,
      text: "Framework C: Percentage of Dimensions Accurate and Consistent",
      font: {
        size: 15
      }
    }
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      ticks: {
        callback: function(value, index, values) {
          return value+"%";
        }
      }
    },
  },
};

const frameworkC1Data = {
  labels: ["50% Threshold", "65% Threshold"],
  datasets: [
    {
      label: "Autonomy",
      backgroundColor: barColor[0],
      borderColor: barColor[0],
      data: [63,25],
      borderWidth: 1,
    },
    {
      label: "Impact",
      backgroundColor: barColor[1],
      borderColor: barColor[1],
      data: [100,63],
      borderWidth: 1,
    },
    {
      label: "Overall",
      backgroundColor: barColor[2],
      borderColor: barColor[2],
      data: [81,44],
      borderWidth: 1,
    }
  ],
};

export {frameworkC1Data, frameworkC1Options};